import { useQuery } from '@apollo/client'
import { ExpensableGroupsStatusCountsDocument } from 'generated/resources/graphql'

import type { StatusCounts } from 'modules/expenses/components/expenses/DataCollection/useDataCollectionConfig'

interface UseExpensableGroupsStatusCountsParams {
  companyId: number
  employeeIds?: number[]
  from?: Date
  to?: Date
}

export const useExpensableGroupsStatusCounts = ({
  companyId,
  employeeIds,
  from,
  to,
}: UseExpensableGroupsStatusCountsParams): StatusCounts | undefined => {
  const { data } = useQuery(ExpensableGroupsStatusCountsDocument, {
    variables: {
      companyId,
      employeeIds,
      from,
      to,
    },
    fetchPolicy: 'cache-and-network',
  })

  if (!data) {
    return undefined
  }

  return {
    draft: data.expenses.draftCount.totalCount ?? 0,
    pending: data.expenses.pendingCount.totalCount ?? 0,
    approved: data.expenses.approvedCount.totalCount ?? 0,
    paid: data.expenses.paidCount.totalCount ?? 0,
  }
}
